
<div class="relative-container">
  <template v-if="listView">
    <div :class="{'list-view-filters container': isFromDashboard}">
      <list-view-header v-if="hasFilters || isFormability" :listView="listView"></list-view-header>

      <div v-if="isFromDashboard">
        <dashboard-drilldown-filters/>
      </div>
    </div>

    <div class="c-row container justify-content-between">
      <list-view-table-meta-links
        class="mx-0"
        :total-count="objectModelEntriesTotalCount"
        :show-view-all="false"
        :show-connected-text="opts.showConnectedText"
      ></list-view-table-meta-links>

      <p v-if="hasFilters" class="desc">
        <button type="button" class="btn-link" @click="clearQueryFilters">
          Clear all filters
        </button>
      </p>
    </div>

    <list-view-scrollable-table
      :listView="listView"
      :is-embedded="false"
      :entries="entries"
      :has-filters="hasFilters"
      :preview="preview"
    ></list-view-scrollable-table>
  </template>
</div>
